module.exports = __webpack_public_path__ + "img/Katarina_acc_11.a3c25abe.jpg";